<template>
  <v-dialog v-model="dialog" width="500" scrollable>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <add-button v-if="!item.id"></add-button>
        <edit-icon-button v-else></edit-icon-button>
      </div>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text class="pb-0 pt-2">
        <v-form ref="form" v-model="isValid">
          <v-text-field
            v-model="form.landmark"
            label="Name / Landmark"
            dense
            type="text"
            outlined
            :rules="rules"
          ></v-text-field>

          <v-text-field
            v-model="form.address"
            label="Address"
            dense
            outlined
            :rules="rules"
          ></v-text-field>
          <v-autocomplete
            v-model="form.zipcode"
            label="Zipcode"
            dense
            :items="zipcodes"
            outlined
            item-text="name"
            item-value="id"
            :rules="rules"
          ></v-autocomplete>
          <v-text-field
            v-model="form.map_link"
            label="Map"
            dense
            outlined
            :rules="rules"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher " text color="green" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getDateTime, getFormDoc } from "../../assets/js/common";
import { cmp } from "../../assets/js/firebase";
import { FIELD } from "../../assets/js/rules";
import AddButton from "../buttons/AddButton.vue";
import EditIconButton from "../buttons/EditIconButton.vue";
export default {
  components: { AddButton, EditIconButton },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isJob: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: false,
      dialog: false,
      form: {},
      rules: FIELD,
    };
  },
  computed: {
    title() {
      return this.item.id ? "Edit CMP" : "Add New CMP";
    },
    zipcodes() {
      return this.$store.getters.zipcodes.map((item) => {
        let { zipcode, community, zone } = item;
        let doc = {};
        doc.id = item.id;
        doc.name = `${zipcode} / ${community} / ${zone}`;
        return doc;
      });
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.form = {
        address: "",
        zipcode: "",
        map_link: "",
        landmark: "",
      };
      if (vm.item.id) {
        Object.keys(vm.form).forEach((key) => {
          let val = vm.item[key];
          if (val !== undefined) vm.form[key] = val;
        });
      }
    },
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let doc = getFormDoc(vm.form);
      if (vm.item.id) {
        vm.update(doc);
      } else {
        vm.create(doc);
      }
    },
    async update(doc) {
      const vm = this;
      try {
        let { id } = vm.item;
        vm.$loader.show();
        let snap = await cmp.where("address", "==", doc.address).limit(1).get();
        if (!snap.empty && snap.docs[0].id != id) {
          vm.$loader.hide();
          vm.$root.alert(
            "Another address already exists. Please enter a unique address."
          );
          return;
        }
        doc.updated_at = getDateTime(new Date());
        await cmp.doc(id).update(doc);
        vm.dialog = false;
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$root.alert(error.message);
      }
    },
    async create(doc) {
      const vm = this;
      try {
        vm.$loader.show();
        let snap = await cmp.where("address", "==", doc.address).limit(1).get();
        if (!snap.empty) {
          vm.$loader.hide();
          vm.$alert.show(
            "Another address already exists. Please enter a unique address."
          );
          return;
        }
        doc.created_at = getDateTime(new Date());
        doc.updated_at = getDateTime(new Date());
        await cmp.add(doc);
        vm.dialog = false;
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style></style>
